import { render, staticRenderFns } from "./ClientContactInfo.vue?vue&type=template&id=6d8886ea"
import script from "./ClientContactInfo.vue?vue&type=script&lang=js"
export * from "./ClientContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports